/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';
import { authenticationError, isAuthenticationPending } from '@auth/store/auth.selectors';
import { AuthState } from '@auth/store/auth.state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as AuthActions from '../store/auth.actions';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  public username = '';
  public password = '';
  public error$: Observable<any>;
  public isPending$: Observable<boolean>;

  constructor(private store: Store<AuthState>) { }

  ngOnInit(): void {
    this.error$ = this.store.select(authenticationError);
    this.isPending$ = this.store.select(isAuthenticationPending);
  }

  onLogin(): void {
    this.store.dispatch(new AuthActions.Login({
      username: this.username,
      password: this.password
    }));
  }
}
